import Config from '../config';
import { handleErrors } from '../utils/requestHelpers';
import fetch from '../utils/fetchService';

export const updateUserPreferences = async preferences => await fetch(
  Config.endpoints.UPDATE_USER_PREFERENCES,
  {
    method: 'PUT',

    body: JSON.stringify(preferences),
  }
)
  .then(handleErrors({ errorMessage: 'Updating User Preferences failed' }));

export const updateUserLastClient = clientId => fetch(
  Config.endpoints.UPDATE_USER_LAST_CLIENT,
  {
    method: 'PUT',

    body: JSON.stringify({ clientId }),
  }
)
  .then(handleErrors({ errorMessage: 'Updating User Last Client failed' }));
